import { createRouter, createWebHistory } from 'vue-router'
import BreathingExercises from '@/views/BreathingExercises.vue'
import GiftPage from '@/views/GiftPage.vue'
import AndroidWaitlist from '@/views/AndroidWaitlist.vue'
import MonthlyPromo from '@/views/MonthlyPromo.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: BreathingExercises
  },
  {
    path: '/gift',
    name: 'Gift',
    component: GiftPage
  },
  {
    path: '/android-coming-soon',
    name: 'AndroidWaitlist',
    component: AndroidWaitlist
  },
  {
    path: '/monthlypromo',
    name: 'MonthlyPromo',
    component: MonthlyPromo
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
